var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  style: {
    transform: "rotate(-180deg)"
  },
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.53 2.53a.75.75 0 0 0-1.06-1.06l-6 6a.748.748 0 0 0-.22.528v.004a.748.748 0 0 0 .22.528l6 6a.75.75 0 0 0 1.06-1.06L3.81 8.75H14a.75.75 0 0 0 0-1.5H3.81l4.72-4.72z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export default ForwardRef;